import { motion } from 'framer-motion';
import { API } from '@/lib/apiConfig';
import { useAuthStore } from '../stores/auth';

export function SSOButton() {
  const setUser = useAuthStore((s) => s.setUser);

  const login = async () => {
    // Open Google OAuth in a new window; backend should set a session cookie
    const w = window.open(API.auth + '/auth/google', '_blank', 'width=480,height=640');
    const poll = setInterval(async () => {
      try {
        const res = await fetch(API.auth + '/auth/me', { credentials: 'include' });
        if (res.ok) {
          const data = await res.json();
          if (data?.user) { setUser(data.user); clearInterval(poll); if (w) w.close(); }
        }
      } catch {}
    }, 1000);
  };

  return (
    <motion.button onClick={login} whileTap={{ scale: 0.97 }} className="px-3 py-1 rounded border border-evat-neon text-evat-neon hover:shadow-neon">
      Enterprise Login (SSO)
    </motion.button>
  );
}

export default SSOButton;


